(function () {
	const OPEN_CLASS = "list-menu--megamenu-visible";
	const OPEN_DELAY = 80;
	const CLOSE_DELAY = 500;

	const setExpanded = (item, expanded) => {
		item.classList.toggle(OPEN_CLASS, expanded);
		const trigger = item.querySelector(":scope > .header__menu-item");
		if (trigger) trigger.setAttribute("aria-expanded", String(expanded));
	};

	const initializeHeader = (root = document) => {
		const items = Array.from(root.querySelectorAll(".list-menu--megamenu"));

		items.forEach((item, itemIndex) => {
			if (item.dataset.megaMenuReady === "true") return;
			item.dataset.megaMenuReady = "true";

			const trigger = item.querySelector(":scope > .header__menu-item");
			const panel = item.querySelector(":scope > .mega-menu");
			let openTimer;
			let closeTimer;

			const cancelOpen = () => window.clearTimeout(openTimer);
			const cancelClose = () => window.clearTimeout(closeTimer);
			const closeSiblings = () => {
				items.forEach((other) => {
					if (other !== item) setExpanded(other, false);
				});
			};
			const open = () => {
				cancelOpen();
				cancelClose();
				closeSiblings();
				setExpanded(item, true);
			};
			const scheduleOpen = () => {
				cancelOpen();
				cancelClose();
				openTimer = window.setTimeout(open, OPEN_DELAY);
			};
			const scheduleClose = () => {
				cancelOpen();
				cancelClose();
				closeTimer = window.setTimeout(() => setExpanded(item, false), CLOSE_DELAY);
			};

			item.addEventListener("mouseenter", scheduleOpen);
			item.addEventListener("mouseleave", scheduleClose);
			item.addEventListener("focusin", open);
			item.addEventListener("focusout", (event) => {
				if (!item.contains(event.relatedTarget)) scheduleClose();
			});

			if (!trigger) return;
			trigger.setAttribute("aria-haspopup", "true");
			if (panel) {
				panel.id ||= `MegaMenu-${itemIndex + 1}`;
				trigger.setAttribute("aria-controls", panel.id);
			}
			trigger.addEventListener("click", (event) => {
				event.preventDefault();
				if (item.classList.contains(OPEN_CLASS)) setExpanded(item, false);
				else open();
			});
			trigger.addEventListener("keydown", (event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					open();
					item.querySelector(".mega-menu a")?.focus();
				}
			});
			item.addEventListener("keydown", (event) => {
				if (event.key !== "Escape" || !item.classList.contains(OPEN_CLASS)) return;
				event.preventDefault();
				setExpanded(item, false);
				trigger.focus();
			});
		});

		if (root === document && document.documentElement.dataset.megaMenuOutsideReady !== "true") {
			document.documentElement.dataset.megaMenuOutsideReady = "true";
			document.addEventListener("pointerdown", (event) => {
				if (event.target.closest(".list-menu--megamenu")) return;
				document.querySelectorAll(`.${OPEN_CLASS}`).forEach((item) => setExpanded(item, false));
			});
		}
	};

	document.addEventListener("shopify:section:load", (event) => initializeHeader(event.target));
	initializeHeader();
})();
